import Meister from './src/js/Meister';

export default Meister;



// WEBPACK FOOTER //
// ./index.js